import React from 'react'
import { Divider, ExpandableListItem, List, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { TreeLink } from '../../app/Links'
import ObjectView from '../../common/ObjectView'
import useUserOwnedTrees from './useUserOwnedTrees'
import useUserParticipantTrees from './useUserParticipantTrees'
import { usePageTitle } from '../../app/PageTitleContext'

export default function UserOwnedTrees() {
  usePageView({ page_detail: 'DMConsole:UserTrees' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.user.trees'))
  const { participantTrees } = useUserParticipantTrees()
  const { ownedTrees } = useUserOwnedTrees()

  return (
    <>
      {ownedTrees.length > 0 && (
        <>
          <span>{t('user.trees.ownedTrees', 'Trees Owned by User')}</span>
          <Divider />
          <List id="userOwnedTreesList">
            {ownedTrees?.map((ownedTree) => (
              <React.Fragment key={ownedTree.tree.treeId}>
                <span>
                  <ExpandableListItem
                    id={`listitem - ${ownedTree.tree.treeId}`}
                    primaryText={
                      <TreeLink
                        treeId={ownedTree.tree.treeId}
                        treeName={ownedTree.tree.name}
                        treeType={ownedTree.treeType}
                      />
                    }
                    secondaryText={ownedTree.tree.tombstoned ? t('tombstoned', 'Tombstoned') : null}
                    selected={ownedTree.tree.tombstoned}
                  >
                    <ObjectView object={ownedTree.tree} fieldsToOmit={['devkeys']} />
                  </ExpandableListItem>
                </span>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </>
      )}
      {participantTrees.length > 0 && (
        <>
          <Separator size="lg" />
          <span>{t('user.trees.participantTrees', 'Trees User Participates In')}</span>
          <Divider />
          <List id="userParticipantTreesList">
            {participantTrees?.map((participantTree) => (
              <React.Fragment key={participantTree.tree.treeId}>
                <span>
                  <ExpandableListItem
                    id={`listitem - ${participantTree.tree.treeId}`}
                    primaryText={
                      <TreeLink
                        treeId={participantTree.tree.treeId}
                        treeName={participantTree.tree.name}
                        treeType={participantTree.treeType}
                      />
                    }
                    secondaryText={participantTree.tree.tombstoned ? t('tombstoned', 'Tombstoned') : null}
                    selected={participantTree.tree.tombstoned}
                  >
                    <ObjectView object={participantTree.tree} fieldsToOmit={['devkeys']} />
                  </ExpandableListItem>
                </span>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </>
      )}
    </>
  )
}
